import { EffectsMap } from 'use-effect-reducer'
import {
  CNP_EVENT,
  PAYMENT_STATUS,
} from '@lightspeed-payments/payments-terminal-sdk'
import { getPaymentErrorMessage } from '../../helpers/errorChecking'
import { processLSPayPaymentMethodOnFile } from '../../../../../functions/payment-types/lspayPmof'
import {
  SWIPER_ERROR_CODES,
  TRANSACTION_TYPE,
} from '../../helpers/lspayConstants'
import { LSPAYErrorMessage } from '../../helpers/lspay.types'
import { PMOFEffect, PMOFEffectsMapArgs, PMOFEvent, PMOFState } from './types'

export const getPMOFEffectsMap = (
  args: PMOFEffectsMapArgs
): EffectsMap<PMOFState, PMOFEvent, PMOFEffect> => {
  const {
    amount,
    customerId,
    paymentMethodOnFileId,
    register,
    registerSaleId,
    setSwiperError,
    terminalMonitoringInstance,
    transactionId,
  } = args

  return {
    processPaymentEffect: (_state, _effect, dispatch) => {
      if (!customerId || !paymentMethodOnFileId) {
        return
      }

      terminalMonitoringInstance?.sendEvent(CNP_EVENT.START, {
        transactionType: TRANSACTION_TYPE.PAYMENT,
      })

      processLSPayPaymentMethodOnFile(
        amount.toNumber(),
        customerId,
        paymentMethodOnFileId,
        register.id,
        register.name,
        registerSaleId || '',
        transactionId
      )
        .then(transaction => {
          terminalMonitoringInstance?.sendEvent(CNP_EVENT.COMPLETE, {
            payment: {
              status: PAYMENT_STATUS.APPROVED,
            },
            transactionType: TRANSACTION_TYPE.PAYMENT,
          })
          dispatch({ type: 'DONE', transaction })
        })
        .catch(error => {
          terminalMonitoringInstance?.sendEvent(CNP_EVENT.COMPLETE, {
            payment: {
              status: PAYMENT_STATUS.ERROR,
              reason: error.message || 'Payment processing failed',
            },
            ...(error.code && {
              error: {
                code: error.code?.toString(),
                message: error.message || '',
              },
            }),
            transactionType: TRANSACTION_TYPE.PAYMENT,
          })

          if (Object.values(SWIPER_ERROR_CODES).includes(error.code)) {
            setSwiperError(error)
            return
          }

          const errorMessage: LSPAYErrorMessage = getPaymentErrorMessage(error)
          dispatch({ type: 'ERROR', errorMessage })
        })
    },
  }
}
